var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg8KUpscale = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08366 7.94428H4.70403C5.06051 7.94428 5.35218 7.65262 5.35218 7.29613V4.70354C5.35218 4.34706 5.06051 4.05539 4.70403 4.05539H3.08366C2.72718 4.05539 2.43551 4.34706 2.43551 4.70354V7.29613C2.43551 7.65262 2.72718 7.94428 3.08366 7.94428ZM3.40773 4.70354H4.37996V5.67576H3.40773V4.70354ZM3.40773 6.32391H4.37996V7.29613H3.40773V6.32391Z",
    fill: "#AEB3B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5374 0.166504H1.46329C0.750326 0.166504 0.166992 0.749837 0.166992 1.4628V10.5369C0.166992 11.2498 0.750326 11.8332 1.46329 11.8332H10.5374C11.2503 11.8332 11.8337 11.2498 11.8337 10.5369V1.4628C11.8337 0.749837 11.2503 0.166504 10.5374 0.166504ZM11.0004 10.9998H1.00037V0.999832H11.0004V10.9998Z",
    fill: "#AEB3B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6207 6.48595L8.75496 7.94428H9.88921L8.43088 5.99984L9.88921 4.05539H8.75496L7.6207 5.51373V4.05539H6.64847V7.94428H7.6207V6.48595Z",
    fill: "#AEB3B6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg8KUpscale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/8k-upscale.176a0fb04c343c9bcf37686036bee66d.svg";